import Backbone from "backbone";
import * as _ from "underscore";

// This is read-only - doesn't write anything to server

const PrivateBookTagsCollection = Backbone.Collection.extend({
  initialize: function () {
    this._activeTag = this.DEFAULT_TAG;
    this._tags = [
      {
        name: "all",
        displayName: "All",
        alwaysVisible: true,
      },
      {
        name: "queue",
        displayName: "To Read",
        icon: "book",
        alwaysVisible: true,
      },
      {
        name: "completed",
        displayName: "Completed",
        icon: "trophy",
      },
      {
        name: "abandoned",
        displayName: "Archived",
        icon: "archive",
      },
      {
        name: "shared",
        displayName: "Shared",
        icon: "share",
      },
      {
        name: "deleted",
        displayName: "Deleted",
        icon: "trash",
      },
    ];
  },
  url: "/api/bookTags",
});

PrivateBookTagsCollection.prototype.DEFAULT_TAG = "queue";

PrivateBookTagsCollection.prototype.addTags = function (tags, previousTags) {
  _.each(tags, (tagName) => {
    const tag = this.findWhere({ name: tagName });
    if (tag) {
      tag.set({ count: tag.get("count") + 1 });
      if (_.contains(["queue", "completed", "abandoned"], tag.get("name"))) {
        const allTag = this.findWhere({ name: "all" });
        allTag.set({ count: allTag.get("count") + 1 });
      }
    } else {
      this.add(
        new Backbone.Model({
          name: tagName,
          count: 1,
        })
      );
    }
    if (previousTags.length === 0 && tags.length > 0) {
      const deletedTag = this.findWhere({ name: "deleted" });
      deletedTag.set({ count: deletedTag.get("count") - 1 });
    }
  });
};

PrivateBookTagsCollection.prototype.tagInfo = function (tagName) {
  return _.findWhere(this._tags, { name: tagName });
};

PrivateBookTagsCollection.prototype.removeTags = function (
  tags,
  remainingTags
) {
  _.each(tags, (tagName) => {
    const tag = this.findWhere({ name: tagName });
    if (tag) {
      const count = tag.get("count");
      tag.set({ count: count - 1 });

      if (_.contains(["queue", "completed", "abandoned"], tag.get("name"))) {
        const allTag = this.findWhere({ name: "all" });
        allTag.set({ count: allTag.get("count") - 1 });
      }
    }
  });

  if (
    _.intersection(["queue", "completed", "abandoned"], remainingTags)
      .length === 0
  ) {
    const deletedTag = this.findWhere({ name: "deleted" });
    deletedTag.set({ count: deletedTag.get("count") + 1 });
  }
};

PrivateBookTagsCollection.prototype.removeDeletedBook = function () {
  const deletedTag = this.findWhere({ name: "deleted" });
  deletedTag.set({ count: deletedTag.get("count") - 1 });
};

// Tag current being viewed
PrivateBookTagsCollection.prototype.activeTag = function () {
  return this._activeTag;
};

PrivateBookTagsCollection.prototype.setActiveTag = function (tagName) {
  if (this._activeTag !== tagName) {
    this._activeTag = tagName;
    this.trigger("change:activeTag", tagName);
  } else {
    this._activeTag = tagName;
  }
};

PrivateBookTagsCollection.prototype.viewJSON = function () {
  _.each(this._tags, (tag) => {
    const tagModel = this.findWhere({ name: tag.name });
    if (tagModel) {
      tag.count = tagModel.get("count");
      tag.showCount = true;
    } else {
      tag.count = 0;
      tag.showCount = _.contains(
        ["queued", "completed", "abandoned", "deleted", "all"],
        tag.name
      );
    }
    tag.active = tag.name === this._activeTag;
    tag.visible = tag.alwaysVisible || tag.showCount;
    tag.value = tag.name;
  });

  return {
    tags: this._tags,
  };
};

export default PrivateBookTagsCollection;
